import React from "react";
import { Navigate, NavLink, Outlet } from "react-router-dom";
import { Heart, Home, MessageSquareWarning, Search, UserRound } from "lucide-react";
import { useResident } from "@/lib/residentAuth";
import { Wordmark } from "@/components/Brand";
import { ListSkeleton } from "@/components/common";

const NAV = [
  { to: "/resident", label: "Home", Icon: Home, id: "home" },
  { to: "/resident/search", label: "Find PG", Icon: Search, id: "search" },
  { to: "/resident/saved", label: "Saved", Icon: Heart, id: "saved" },
  { to: "/resident/complaints", label: "Complaints", Icon: MessageSquareWarning, id: "complaints" },
  { to: "/resident/profile", label: "Profile", Icon: UserRound, id: "profile" },
];

export default function ResidentShell() {
  const { resident } = useResident();
  if (resident === undefined) return <div className="max-w-md mx-auto p-6 pt-24"><ListSkeleton rows={3} /></div>;
  if (!resident) return <Navigate to="/resident/login" replace />;
  return (
    <div className="min-h-screen bg-[#f7f9fc]">
      <header className="sticky top-0 z-30 h-16 border-b border-[#e3e8ef] bg-white/85 backdrop-blur-md">
        <div className="max-w-md mx-auto h-full px-4 flex items-center justify-between">
          <Wordmark size={26} />
          <span className="text-[11px] font-bold uppercase tracking-wider text-[#131e2e] bg-[#fccc00] rounded-full px-2.5 py-1">Resident</span>
        </div>
      </header>
      <main className="max-w-md mx-auto px-4 pt-5 pb-28"><Outlet /></main>
      <nav className="fixed bottom-0 inset-x-0 z-40 border-t border-[#e3e8ef] bg-white/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]">
        <div className="max-w-md mx-auto grid grid-cols-5">
          {NAV.map(({ to, label, Icon, id }) => (
            <NavLink key={to} to={to} end={to === "/resident"} data-testid={`resident-nav-${id}`}
              className={({ isActive }) => `flex flex-col items-center justify-center gap-1 h-16 text-[11px] font-semibold ${isActive ? "text-[#131e2e]" : "text-slate-500"}`}>
              {({ isActive }) => (<><span className={`grid place-items-center h-8 w-12 rounded-full ${isActive ? "bg-[#e8f1fb]" : ""}`}><Icon className="h-5 w-5" /></span>{label}</>)}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
